module.exports = __webpack_public_path__ + "static/media/img1.e4d7696d.png";